export default {
      id: "ic_plus-usage",
      viewBox: "0 0 20 20",
      url: "../dist/images/" + "sprite.svg#ic_plus-usage",
      toString: function () {
        return this.url;
      }
    }